import type { ISchemaContainer } from '../../../../../../common/validation/schemaContainer';
import type { ValidationErrors } from '../../../../../utils/validation';
import type { AddRightsAction } from '../careProviderAddRightsReducer';
import { updateValidationErrorsForOne } from '../../../../../utils/validation';

export function validateOneAddRights<TSchemaResult, TObject>(
    validationSchema: ISchemaContainer<TSchemaResult>,
    object: TObject,
    name: string,
    errorsStateObject: ValidationErrors,
    setErrorsAction: React.Dispatch<AddRightsAction>
) {
    setErrorsAction({
        type: 'setErrors',
        errors: updateValidationErrorsForOne(validationSchema, object, errorsStateObject, name),
    });
}
